import { EventEmitter, useMount } from '@apia/util';
import { useState } from 'react';
import { OpenModal, TOpenModal } from './OpenModal';

export class ApiaUtilModalHandler {
  constructor(
    private id: string,
    public close: () => void,
  ) {}
}

export class ApiaUtilModals {
  #emitter = new EventEmitter<{
    close: string;
    closeAll: boolean;
    open: TOpenModal;
  }>();
  #maxId = 0;

  constructor() {
    document.addEventListener('openModal', (event) => {
      const cevent = event as CustomEvent;

      this.open(cevent.detail as TOpenModal);
    });
  }

  close(id: string) {
    this.#emitter.emit('close', id);
  }

  open(props: TOpenModal) {
    const id = props.id ?? `modal_${this.#maxId++}`;

    this.#emitter.emit('open', { ...props, id });

    return new ApiaUtilModalHandler(id, () => {
      this.#emitter.emit('close', id);
    });
  }

  #useModalsList = () => {
    const [modals, setModals] = useState<(TOpenModal & { isOpen: boolean })[]>(
      [],
    );

    useMount(() => {
      const u1 = this.#emitter.on('open', (ev) => {
        setModals((current) => [
          ...current,
          {
            ...ev,
            isOpen: true,
            onClose: ev.onClose,
            onExited: () => {
              ev.onExited?.();
              setModals((current) =>
                current.filter((modal) => modal.id !== ev.id),
              );
            },
          },
        ]);
      });
      const u2 = this.#emitter.on('closeAll', () => {
        setModals((current) =>
          current.map((modal) => ({ ...modal, isOpen: false })),
        );
      });
      const u3 = this.#emitter.on('close', (modalId) => {
        setModals((current) =>
          current.map((modal) =>
            modal.id === modalId ? { ...modal, isOpen: false } : modal,
          ),
        );
      });

      return () => {
        u1();
        u2();
        u3();
      };
    });

    return modals;
  };

  Component = () => {
    const modals = this.#useModalsList();

    return (
      <>
        {modals.map((current) => (
          <OpenModal key={current.id} {...current} />
        ))}
      </>
    );
  };
}
